// AUTH
export const LOGOUT_USER = 'LOGOUT_USER'
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS'
export const ACTIVATE_ACCOUNT = 'ACTIVATE_ACCOUNT'
export const CHANGE_FIRST_LOADING = 'CHANGE_FIRST_LOADING'

// USER
export const GET_DETAIL_USER = 'GET_DETAIL_USER'
export const GET_ALL_USER = 'GET_ALL_USER'
export const CLEAR_USER_STATE = 'CLEAR_USER_STATE'

// ROOM
export const GET_MY_ROOM = 'GET_MY_ROOM'
export const GET_MY_ROOM_STATIC = 'GET_MY_ROOM_STATIC'
export const GET_MEMBER_IN_ROOM = 'GET_MEMBER_IN_ROOM'
export const GET_DETAIL_ROOM = 'GET_DETAIL_ROOM'
export const CLEAR_DETAIL_ROOM = 'CLEAR_DETAIL_ROOM'
export const GET_GROUP_ROOM = 'GET_GROUP_ROOM'
export const GET_PRIVATE_ROOM = 'GET_PRIVATE_ROOM'
export const CLEAR_ROOM_STATE = 'CLEAR_ROOM_STATE'

// FRIEND
export const GET_MY_FRIEND = 'GET_MY_FRIEND'
export const CLEAR_FRIEND_STATE = 'CLEAR_FRIEND_STATE'
export const ADD_FRIEND = 'ADD_FRIEND'

// MESSAGE
export const GET_DETAIL_MESSAGE = 'GET_DETAIL_MESSAGE'
export const CLEAR_DETAIL_MESSAGE = 'CLEAR_DETAIL_MESSAGE'
export const CLEAR_MESSAGE_STATE = 'CLEAR_MESSAGE_STATE'
export const DELETE_MESSAGE = 'DELETE_MESSAGE'
export const MESSAGE_PUSH = 'MESSAGE_PUSH'
export const GET_IMAGE_MESSAGE = 'GET_IMAGE_MESSAGE'
export const GET_DOCUMENT_MESSAGE = 'GET_DOCUMENT_MESSAGE'

// STORY
export const GET_FRIEND_STORY = 'GET_FRIEND_STORY'
export const GET_DETAIL_STORY = 'GET_DETAIL_STORY'
export const GET_MY_STORY = 'GET_MY_STORY'
export const GET_DETAIL_STORY_ONE = 'GET_DETAIL_STORY_ONE'
export const CLEAR_STORY_STATE = 'CLEAR_STORY_STATE'
export const GET_CURRENT_STORY = 'GET_CURRENT_STORY'
export const GET_VIEWERS_STORY = 'GET_VIEWERS_STORY'

// GLOBAL
export const CHANGE_THEME = 'CHANGE_THEME'
export const GET_STICKER = 'GET_STICKER'

// CALL
export const CHANGE_CALL_STATUS = 'CHANGE_CALL_STATUS'
export const UPDATE_DATA_PRIVATE_CALL = 'UPDATE_DATA_PRIVATE_CALL'
export const RESET_DATA_PRIVATE_CALL = 'RESET_DATA_PRIVATE_CALL'
export const CLEAR_CALL_STATE = 'CLEAR_CALL_STATE'
